import { OfferLetterDealStageEnum } from "api/resources/offerLetter/types"
import { getDeliveryModeBadge } from "features/LearningItems/getProductDisplayConfig"
import { useGlobalContext } from "global/Context/context"
import { useMemo } from "react"
import { BROWSER_STORAGE_KEYS } from "utils/constants"
import { UserPreferenceManager } from "utils/userPreferenceManager"

const { pgctlOfferLetterViewedAt, pgctlWelcomeModalViewedAt } =
  BROWSER_STORAGE_KEYS

export enum PgCTLOfferLetterDialog {
  OfferLetter = "offer-letter-dialog",
  Welcome = "welcome-dialog",
}

export const usePgCTLOfferLetter = () => {
  const { offerLetter: offerLetterQuery } = useGlobalContext()

  const offerLetter = offerLetterQuery.data ?? null

  const isRegistrationDone = useMemo(
    () => offerLetter?.dealStage === OfferLetterDealStageEnum.registrationDone,
    [offerLetter]
  )
  const isOfferLetterSent = useMemo(
    () => offerLetter?.dealStage === OfferLetterDealStageEnum.offerLetterSent,
    [offerLetter]
  )

  const hasViewedOfferLetter = Boolean(
    UserPreferenceManager.get(pgctlOfferLetterViewedAt)
  )

  const hasViewedWelcomeModal = Boolean(
    UserPreferenceManager.get(pgctlWelcomeModalViewedAt)
  )
  const markViewed = {
    offerLetter: () => {
      UserPreferenceManager.set(
        pgctlOfferLetterViewedAt,
        new Date().toISOString()
      )
    },
    welcomeModal: () => {
      UserPreferenceManager.set(
        pgctlWelcomeModalViewedAt,
        new Date().toISOString()
      )
    },
  }

  const deliveryModeBadge = useMemo(
    () =>
      offerLetter
        ? getDeliveryModeBadge({ slug: offerLetter.product.slug })
        : null,
    [offerLetter]
  )

  return {
    // offerLetter: {
    //   isSent: isOfferLetterSent,
    //   isViewed: hasViewedOfferLetter,
    //   markViewed,
    //   data: offerLetter
    // },
    hasViewedOfferLetter,
    hasViewedWelcomeModal,
    offerLetter,
    markViewed,
    isRegistrationDone,
    isOfferLetterSent,
    deliveryModeBadge,
    query: offerLetterQuery,
  }
}
